import HeadText from "../components/HeadText";
import ChildTitle from "../components/ChildTitle";
import Footer from "../components/Footer";
import Header from "../components/Header";
import { EducationContent, EducationSub } from "../components/education";

// ----------------------------------------------------------------------

export default function EducationPage({
  web3Modal,
  loadWeb3Modal,
  logoutOfWeb3Modal,
}) {
  return (
    <>
      <Header
        web3Modal={web3Modal}
        loadWeb3Modal={loadWeb3Modal}
        logoutOfWeb3Modal={logoutOfWeb3Modal}
      />
      <div className="page">
        <HeadText title={"EDUCATION"} />
        <EducationSub />
        <ChildTitle title={"WALLET"} />
        <EducationContent />
      </div>

      <Footer />
    </>
  );
}
